<template>
	<span></span>
</template>
<script lang="js">
import { getAppData, debug } from '@/utils';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			url: '',
		};
	},
	computed: {
		...mapGetters(['userEmail', 'userFirstName', 'userLastName']),
	},
	mounted() {
		this.$bus.$on('triggerUpgradeWindow', this.openComms);
	},
	beforeDestroy() {
		this.$bus.$off('triggerUpgradeWindow', this.openComms);
		this.detach();
	},
	methods: {
		openComms(url) {
			if (this.interval) {
				return;
			}
			this.url = url;
			this.tab = window.open(this.url, '_blank');
			this.$store.commit('loading', 'upgrade');
			window.addEventListener('message', this.listenMessage);

			// Continue checking to see if upgrade is still in process.
			this.timePassed = 0;
			this.interval = setInterval(() => this.maybeDetach(), 2000);
		},
		listenMessage(evt) {
			const { origin, data } = evt;
			if (origin.replace(/\/$/, '') !== this.$urls.app().replace(/\/$/, '')) {
				return;
			}

			if (!data || 'string' !== typeof data) {
				return;
			}

			try {
				// Get passed status.
				const data = JSON.parse(evt.data);

				// Set with: localStorage.setItem('omWpDebug', 'upgrade')
				if (debug.enabled('upgrade')) {
					// eslint-disable-next-line no-console
					console.warn('10-4', data.status, { data });
				}

				// Do action based on status.
				switch (data.status) {
					case 'loaded':
						this.onUpgradeLoaded(data);
						break;
					case 'upgraded':
					case 'complete':
						this.reload();
						break;
					default:
				}
			} catch (error) {
				if (debug.enabled('upgrade')) {
					// eslint-disable-next-line no-console
					console.warn('error', { error, origin, data, evt });
				}
			}
		},
		onUpgradeLoaded() {
			const payload = {
				siteName: getAppData('blogname'),
				partnerId: getAppData('partnerId'),
				user: {
					email: this.userEmail,
					firstName: this.userFirstName,
					lastName: this.userLastName,
				},
			};

			this.message(payload);
		},
		message(payload) {
			if (this.maybeDetach()) {
				return;
			}

			payload = {
				...payload,
				omWizard: true,
				status: 'loaded',
				origin: window.location.protocol + '//' + window.location.host,
			};

			// Set with: localStorage.setItem('omWpDebug', 'upgrade')
			if (debug.enabled('upgrade')) {
				// eslint-disable-next-line no-console
				console.warn('ping ', { to: this.url, payload });
			}

			this.tab.postMessage(JSON.stringify(payload), this.$urls.app());
		},
		maybeDetach() {
			const closed = this.tab && this.tab.closed;
			const expired = 60 < this.timePassed;
			if (closed || expired) {
				this.detach();
				return true;
			}

			this.timePassed += 2;
			return false;
		},
		detach() {
			this.$store.commit('doneLoading', 'upgrade');
			window.removeEventListener('message', this.listenMessage);
			clearInterval(this.interval);
			this.interval = false;

			this.$bus.$emit('upgradeWindowClosed');
		},
		reload() {
			this.$store.commit('doneLoading', 'upgrade');
			window.location.reload();
		},
	},
};
</script>
